"use strict";
// import "doshx_controls_web/lib/index.css"; //Tailwind is being included here.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// import HttpsRedirect from "react-https-redirect";
var client_1 = require("react-dom/client");
var react_redux_1 = require("react-redux");
var store_1 = require("./store");
var app_1 = require("./app");
var react_router_dom_1 = require("react-router-dom");
var root = (0, client_1.createRoot)((_a = document.getElementById("app")) !== null && _a !== void 0 ? _a : document.body);
root.render(
// <HttpsRedirect>
react_1.default.createElement(react_redux_1.Provider, { store: store_1.redux_store },
    react_1.default.createElement(react_router_dom_1.HashRouter, null,
        react_1.default.createElement(app_1.App, null)))
// </HttpsRedirect>
);
